export interface FeedbackRequest {
	marketId: number;
	financialCommunityId: number;
	salesAgreementId: number;
	portalExperience: PortalExperience;
	userType: UserType;
	pageUrl: string;
	ratingQues1: number;
	ratingQues2: number;
	feedbackText: string;
}

export enum PortalExperience {
	PreClose = 'PreClose',
	PostClose = 'PostClose',
}

export enum UserType {
	Customer = 'Customer',
	Realtor = 'Realtor',
}

export interface FeedbackModalData {
	marketId: number;
	financialCommunityId: number;
	salesAgreementId: number;
	portalExperience: PortalExperience;
	userType: UserType;
	pageUrl: string;
	pageName: string;
}
